module.exports = __webpack_public_path__ + "static/img/10038.d190f3d9.png";